var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAgenda = function SvgAgenda(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CE142C",
    d: "M0 0h32v32H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.797 23.52h3.55v-3.48h-3.55zm0-8.297h3.55v-3.48h-3.55zM13.181 8.48c-4.293 0-6.46 2.577-6.46 6.38v8.66h3.449v-3.889h6.091v3.889h3.457v-8.66c0-3.685-2.349-6.38-6.537-6.38m-3.011 6.305a2.765 2.765 0 0 1 3.011-3.079 2.835 2.835 0 0 1 3.08 3.08v1.617H10.17z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAgenda);
export default ForwardRef;